import { useEffect, useState } from 'react'

import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'

export default function ErrorDialog({ error, onClose }) {
  const [open, setOpen] = useState(false)

  useEffect(() => {
    setOpen(true)
  }, [])

  return (
    <Dialog open={open} onClose={() => setOpen(false)} TransitionProps={{ onExited: onClose }}>
      <DialogTitle>エラー</DialogTitle>
      <DialogContent>
        {error.split('\n').map((v, i) => (
          <span key={i}>
            {v}
            <br />
          </span>
        ))}
      </DialogContent>
      <DialogActions>
        <Button color="primary" onClick={() => setOpen(false)}>
          閉じる
        </Button>
      </DialogActions>
    </Dialog>
  )
}
